import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoginOpen: false,
  loginInitialPassword: null,
  isSignupOpen: false,
  loading: false,
  error: null,
  snackbar: {
    open: false,
    message: '',
    severity: 'info',
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openLogin: (state, action) => {
      state.isLoginOpen = true;
      state.loginInitialPassword = action.payload?.password || null;
    },
    closeLogin: (state) => {
      state.isLoginOpen = false;
      state.loginInitialPassword = null;
    },
    openSignup: (state) => {
      state.isSignupOpen = true;
    },
    closeSignup: (state) => {
      state.isSignupOpen = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    showSnackbar: (state, action) => {
      state.snackbar = {
        open: true,
        message: action.payload.message,
        severity: action.payload.severity || 'info',
      };
    },
    hideSnackbar: (state) => {
      state.snackbar.open = false;
    },
  },
});

export const {
  openLogin,
  closeLogin,
  openSignup,
  closeSignup,
  setLoading,
  setError,
  clearError,
  showSnackbar,
  hideSnackbar,
} = uiSlice.actions;

export default uiSlice.reducer;
